<template>
  <BaseModal
    name="AddAboutClientsModal"
    width="420"
    :clickToClose="false"
    :shiftY="0.5"
    @before-close="beforeClose"
    :adaptive="true"
    height="auto"
    classes="tw-app-modal"
  >
    <div class="tw-app-modal__container">
      <button
        type="button"
        class="btn-close tw-app-modal__close"
        @click="$modal.hide('AddAboutClientsModal')"
      ></button>

      <div>
        <div class="tw-app-modal__title">Добавить информацию о клиенте</div>

        <div ref="client_about__text">
          <BaseTextarea
            inputClass="tw-app-input-type-3"
            placeholder=""
            input-name="client_about__text"
            @onInput="updateValue"
            :minHeight="'160'"
            name-sign=""
            :value="dataForEmit.client_about__text"
          >
          </BaseTextarea>
        </div>

        <div class="tw-app-modal__footer">
          <button
            @click="$modal.hide('AddAboutClientsModal')"
            class="tw-app-btn-muted tw-app-btn-muted-lg"
          >
            Отменить
          </button>
          <button
            @click="sendData"
            class="tw-app-btn-primary tw-app-btn-primary-lg"
          >
            Добавить
          </button>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import ObjectService from "@/api/ObjectsService.js";
import BidsService from "@/api/BidsService";
import EventBus from "@/event-bus.js";
import GeneralService from "@/api/GeneralService";

// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  components: {},
  props: {
    stateLoading: {
      type: Boolean,
      default: false,
    },
    optionalParams: {
      type: Object,
    },
  },
  data() {
    return {
      listOptions: [],
      finreestr_funds__id: [],
      dataForEmit: {
        amount: null,
        type: "managerBack",
      },

      //       {
      //    "request_services__type_service_id": 1,
      //    "vehicleId":128,
      //    "date":"2020-05-05",
      //    "ownerId":1,
      //    "city":"Орехово",
      //    "nolimit":true,
      //    “comment”: “текст”
      // }
    };
  },
  methods: {
    beforeClose(event) {
      this.dataForEmit = {};
      Object.keys(this.dataForEmit).forEach((elem, index) => {
        if (this.$refs[elem]) {
          this.$refs[elem].classList.remove("input-error");
        }
      });
    },
    updateValue(data) {
      this.dataForEmit[data.name] = data.value;
      this.$refs[data.name].classList.remove("input-error");
    },

    sendData() {
      GeneralService.editOrCreate(
        `/clients/${this.optionalParams.id.id}/about`,
        this.dataForEmit
      )
        .then((data) => {
          this.$toast.success("Запись добавлена");
          Object.keys(this.dataForEmit).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.remove("input-error");
            }
          });
          EventBus.$emit("updateContentData");
          this.dataForEmit = {};
          this.$modal.hide("AddAboutClientsModal");
        })
        .catch((err) => {
          Object.keys(err.response.data.errors).forEach((elem, index) => {
            if (this.$refs[elem]) {
              this.$refs[elem].classList.add("input-error");
            }
          });
          this.$toast.error(err.response.data.message, { duration: 5000 });
        });
    },
  },
  mounted() {},
  created() {},
  beforeDestroy() {},

  computed: {
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting"]),
  },
};
</script>
